export const resolveWidgetDisplayTitle = ({ widgetConfig, fallbackTitle = '' }) => {
  const mode = widgetConfig?.displayTitleMode ?? 'default';

  if (mode === 'none') return '';

  if (mode === 'custom') {
    return String(widgetConfig?.displayTitle || '').trim();
  }

  return fallbackTitle || '';
};

export const getSingleCompetitionName = (competitionInfos = []) => {
  return competitionInfos.length === 1 ? competitionInfos[0]?.name || '' : '';
};